<template>
  <v-card>
    <v-card-title class="headline colorHeadlineStandard" primary-title>
      {{ $tc('label.car') }}
      <v-spacer />
      <v-icon large @click="$emit('closeDialog', true)">{{ mdiClose }}</v-icon>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="6">
          <v-text-field :label="$t('label.carPlate')" v-model="car.plate" maxlength="64" required hide-details />
        </v-col>
        <v-col cols="6">
          <v-autocomplete
            :label="$tc('label.country')"
            v-model="car.state"
            :items="listCountries"
            item-text="comboBoxName"
            item-value="A3"
            cache-items
            append-icon
            hide-details
            clearable
          />
        </v-col>
      </v-row>
      <v-text-field :label="$t('label.carType')" maxlength="64" v-model="car.type" hide-details />
      <v-text-field :label="$t('label.carColor')" maxlength="64" v-model="car.color" hide-details />
      <v-textarea :label="$t('label.note')" v-model="car.note" maxlength="512" name="input-7-1" hide-details no-resize></v-textarea>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn block color="colorEnter" @click="saveCar">{{ $t('btn.save') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
import Vue from 'vue';
import axios from 'axios';

import { mdiClose } from '@mdi/js';

export default Vue.extend({
  name: 'dataEditCar',
  props: {
    openDialog: Boolean,
  },
  data: () => ({
    listCountries: [],
    car: {
      id: 0,
      plate: '',
      state: '',
      color: '',
      type: '',
      note: '',
    },
    mdiClose: mdiClose,
  }),
  mounted() {
    this.listCountriesLoad();
  },
  methods: {
    saveCar() {
      axios
        .post('/api/v1/car', this.car)
        .then((response) => {
          // Ak je existujuca SPZ (-1) alebo prazdna SPZ (0)
          if (response.data.newCarID === -1) {
            this.$store.commit('globalMessage', this.$i18n.t('msg.errCarPlateExists'));
            return;
          }
          if (response.data.newCarID > 0) {
            this.car.id = response.data.newCarID; // Ak sa zalozi nove vozidlo updatni ID
            this.$emit('newCarID', this.car.id);
            this.$emit('closeDialog', true);
          }
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    listCountriesLoad() {
      this.listCountries = [];
      axios
        .get('/api/v1/countries')
        .then((response) => {
          for (const country of response.data) {
            country.comboBoxName = country.A3 + ' - ' + country.czShort;
          }
          this.listCountries = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
  },
});
</script>
